export const AIR_TICKET_TYPE_ALL = 'all';

export const AirTicketTypeQuery = [
  { value: 'all', label: '全て' },
  { value: '0', label: '変更可' },
  { value: '1', label: '変更不可' }
] as const;

export type AirTicketTypeQueryKey = typeof AirTicketTypeQuery[number]['value'];
